import { ConsentLevel, useConsentState } from '@news-mono/web-common'
import React from 'react'
import { AmpAnalytics } from '../analytics'
import {
    AmpGA4Config,
    AmpGoogleAnalyticsFourProps,
} from './AmpGoogleAnalyticsFourProps'

export const AmpGoogleAnalyticsFour: React.FC<AmpGoogleAnalyticsFourProps> = ({
    gaFourMeasureId,
    article,
}) => {
    const consent = useConsentState()

    const googleAnalyticsFourConfig: AmpGA4Config = {
        vars: {
            GA4_MEASUREMENT_ID: gaFourMeasureId,
            GA4_ENDPOINT_HOSTNAME: 'www.google-analytics.com',
            GOOGLE_CONSENT_ENABLED:
                consent.consentLevel ?? ConsentLevel.Essential,
            WEBVITALS_TRACKING: false,
            PERFORMANCE_TIMING_TRACKING: false,
            DEFAULT_PAGEVIEW_ENABLED: false,
            SEND_DOUBLECLICK_BEACON: false,
            DISABLE_REGIONAL_DATA_COLLECTION: false,
            ENHANCED_MEASUREMENT_SCROLL: false,
        },
        triggers: {
            custom_pageview: {
                enabled: true,
                on: 'visible',
                request: 'ga4Event',
                vars: {
                    ga4_event_name: 'view_item',
                },
                extraUrlParams: {
                    pa: 'detail',
                    pr1: `id${article.id}~nm${article.heading}~br${article.source}~ca${article.topics.primary.id}~va${article.classification?.label}~qt1~pr0`,
                },
            },
        },
    }

    return (
        <AmpAnalytics
            type="googleanalytics"
            config={`https://amp.analytics-debugger.com/ga4.json`}
            data-credentials="include"
            dangerouslySetInnerHTML={{
                __html: `
                <script type="application/json">
                    ${JSON.stringify(googleAnalyticsFourConfig)}
                </script>`,
            }}
        ></AmpAnalytics>
    )
}
